import React, { useEffect } from 'react';
import './supplierCards.scss';
import { getCloudinaryUrl } from './OfficeGallery';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSuppliersStart } from '../../redux/suppliers/slice';
import i18next from 'i18next';

const SupplierCards = ({ locationCode, t }) => {
  const dispatch = useDispatch();
  const { data: suppliers, loading, error } = useSelector((state) => state.suppliers);

  useEffect(() => {
    if (!locationCode) return;
    dispatch(fetchSuppliersStart(locationCode));
  }, [locationCode, dispatch]);

  const isHebrew = i18next.language === 'he';

  return (
    <section className="py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 id="suppliers" className="display-6 fw-bold mb-4">
            {t('carRentalCompanies')}
          </h2>
          <div className="display-6 fw-bold mb-4">{t('carRentalDetails')}</div>
        </div>
        {loading ? (
          <div className="text-center py-5">{t('loading')}</div>
        ) : error ? (
          <div className="text-danger text-center py-5">{t('Error')}: {error}</div>
        ) : suppliers?.branches?.length === 0 ? (
          <div className="text-center py-5">{t('No suppliers found for this location.')}</div>
        ) : (
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>{t('Logo')}</th>
                  <th>{t('Name')}</th>
                  <th>{t('Phone')}</th>
                  {isHebrew && <th>{t('Hours')}</th>}
                  {isHebrew && <th>{t('Pickup Directions')}</th>}
                  <th>{t('Location')}</th>
                  <th>{t('Rating')}</th>
                </tr>
              </thead>
              <tbody>
                {suppliers?.branches?.map((supplier, idx) => (
                  <tr key={idx} itemScope itemType="https://schema.org/Organization">
                    <td>
                      <img
                        src={supplier.logos?.[0] ? getCloudinaryUrl(supplier.logos[0]) : 'https://dummyimage.com/100x100/cccccc/000000&text=No+Logo'}
                        alt={supplier.supplierName || 'No Logo'}
                        loading="lazy"
                        style={{ maxWidth: '100px' }}
                        itemProp="logo"
                      />
                    </td>
                    <td itemProp="name">{supplier.supplierName}</td>
                    <td>
                      {Array.isArray(supplier?.phones) ? (
                        <ul className="list-unstyled p-0 mb-0">
                          {supplier.phones.map((phone, i) => (
                            <li key={i}>
                              <a href={`tel:${phone}`} className="text-decoration-none text-primary" itemProp="telephone">
                                {phone}
                              </a>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <span>{t('noPhoneNumbers')}</span>
                      )}
                    </td>
                    {isHebrew && <td itemProp="openingHours">{supplier.deskHours_he || t('noHours')}</td>}
                    {isHebrew && <td>{supplier.deskDirections_he || t('noPickupDirections')}</td>}
                    <td itemProp="address">{t(supplier.deskLocation) || t('noDeskLocation')}</td>
                    <td>
                      {supplier.googlePlace ? (
                        <span itemProp="aggregateRating" itemScope itemType="https://schema.org/AggregateRating">
                          {t('branchRating')}: <span itemProp="ratingValue">{supplier.googlePlace.rating}</span> / 10
                          <br />
                          <small>{t('basedOn')}&nbsp;<span itemProp="reviewCount">{supplier.googlePlace.userRatingsTotal}</span> {t('reviews')}</small>
                        </span>
                      ) : (
                        <span>{t('noRating')}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export default SupplierCards;
